module.exports = __webpack_public_path__ + "media/images/video/purebarre-go-logo-c76ef33c0d48b667791b22049fc75b79.png";